import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import TimelineOppositeContent, { timelineOppositeContentClasses } from "@mui/lab/TimelineOppositeContent";
import { Stack, Typography } from "@mui/material";
import { CustomAvatar } from "../../components/custom-avatar";
import { DashboardNote } from "../types";
import { TextWithLinks } from "./TextWithLinks";
import { formatUTCDateWithLocalTime, parseMs } from "../../../utils";

const NotesTimeline = ({ notes = [] }: { notes: DashboardNote[] }) => {
  const sortedNotes = [...notes].sort(
    (a: DashboardNote, b: DashboardNote) => parseMs(b.dateCreated) - parseMs(a.dateCreated)
  );

  return (
    <>
      {sortedNotes?.length > 0 && (
        <Stack direction="column" spacing={2}>
          <Typography variant="subtitle1">History</Typography>
          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.4
              }
            }}
          >
            {sortedNotes?.map((n) => {
              return (
                <TimelineItem key={n.id}>
                  <TimelineOppositeContent color="textSecondary" width={300}>
                    <Stack direction="column">
                      <Typography variant="caption">{n.createdByUser || n.createdBy}</Typography>
                      <Typography variant="caption">{formatUTCDateWithLocalTime(n.dateCreated)}</Typography>
                    </Stack>
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot variant="outlined">
                      <CustomAvatar
                        alt={n.createdByUser || n.createdBy}
                        name={n.createdByUser || n.createdBy}
                        sx={{ width: 22, height: 22, fontSize: 12 }}
                      />
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <TextWithLinks text={n.text} />
                  </TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        </Stack>
      )}
    </>
  );
};

export default NotesTimeline;
